export class NpPageRequest {

    searchValue: string;
    pageNum: number;
    pageSize: number;
    sortBy: string;
    sortDir: string;
}